export const homeObjOne = {
  img: require('../../images/bg.jpg'),
  primary: true,
  lightText: true,
  lightTextDesc: true,
  headline: 'Parker    Solar   Probe   &   Solar   Orbiters',
  description:
    'On Sept. 29, NASA’s Parker Solar Probe completed a quick maneuver that positioned the spacecraft for a flyby of Venus next month. Solar Orbiter is the most complex scientific laboratory ever to have been sent to the Sun. Although our life-giving star has been an object of scientific interest for centuries, its behaviour still presents a puzzle for scientists.',
    buttonFirst: 'Learn more',
  };

export const homeObjTwo = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  headline: 'Getting photo from telescope remotely',
  description:
  "The Observing with NASA website of the Harvard-Smithsonian Center for Astrophysics provides an opportunity to conduct free observations and photographing of spacecraft using a network of micro-observational robotic telescopes. In order to organize the observation process, it is necessary to send an e-mail request to receive an image of the space object of interest from the list posted on the website.",
  buttonFirst: 'Learn More',
  imgStart: '',
  img: require('../../images/laptop.png'),
  alt: 'Vault',
  start: ''
};

export const homeObjThree = {
  primary: false,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  headline:
    'As part of the NASA 2050 program',
  description:
  "The project focuses on current heliophysical missions, such as the Parker Solar Probe and the Solar Orbiter, while encouraging users to think about future solar energy exploration, for example, we plan to launch an orbital solar nanotelescope that studies the Sun.",
  buttonFirst: 'Learn more',
  imgStart: 'start',
  img: require('../../images/profile.jpg'),
  alt: 'Vault',
  start: 'true'
};

export const homeObjFour = {
  primary: true,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  headline: 'Changeable weather',
  description:
    'The weather is the background on which a person develops. He studies, works, communicates with people around him, laughs, feels both in summer and in winter. A person cannot feel joy exclusively in summer, and be in a state of sadness and loneliness all autumn. This happens if a person has set himself up for it. And the weather influence on mood.',
    buttonFirst: 'Learn more',
  imgStart: 'start',
  img: require('../../images/bg-3.jpg'),
  alt: 'Vault',
  start: 'true'
};
